import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-797b285f"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = { class: "border-lighten w-full rounded border-t bg-dark-400 py-1.5 px-2 shadow-md" }
const _hoisted_3 = { class: "list-filter-main grid grid-flow-row gap-2 sm:grid-flow-col" }
const _hoisted_4 = { class: "flex flex-wrap gap-2" }

import { Ref, reactive, ref, watch } from 'vue';
import { ListFilterData } from '@/interfaces/list-filter';
import { ListFilterButtonSearchState, ListFilterButtonSortState, ListFilterButtonVariant } from '@/enums/list-filter';
import { useLocationStore } from '@/stores/location';
import { useDropdownIcon } from '@/composables/use-dropdown-icon';
import { TranslateKey, useInject } from '@/composables/use-inject';
import AppIcon from '@/components/Base/AppIcon.vue';
import FieldSearchText from '@/components/Fields/FieldSearchText.vue';
import ItemFavoritesModal from '@/components/ItemFavorites/ItemFavoritesModal.vue';
import { ListFilterExposed } from '@/components/ListFilter/ListFilter.d';
import ListFilterButton from '@/components/ListFilter/ListFilterButton.vue';
import ListFilterButtonContent from '@/components/ListFilter/ListFilterButtonContent.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ListFilter',
  emits: {
  filter: null,
},
  setup(__props, { expose, emit }) {



const translate = useInject(TranslateKey);
const locationStore = useLocationStore();

const favoritesModal: Ref<boolean> = ref(false);

const state: ListFilterData = reactive({
  search: '',
  searchContext: ListFilterButtonSearchState.ALL,
  sortCount: ListFilterButtonSortState.DEFAULT,
  sortPrice: ListFilterButtonSortState.DEFAULT,
  sortGrade: ListFilterButtonSortState.DEFAULT,
});

const getListFilterButtonIcon = (state: ListFilterButtonSortState): string => {
  return useDropdownIcon(
    [ListFilterButtonSortState.DESC, ListFilterButtonSortState.ASC].includes(state),
    state === ListFilterButtonSortState.ASC,
  );
};

const updateButtonSearchState = (key: 'searchContext'): void => {
  if (state[key] === ListFilterButtonSearchState.ALL) {
    state[key] = ListFilterButtonSearchState.BY_CATEGORY;
  } else if (state[key] === ListFilterButtonSearchState.BY_CATEGORY) {
    state[key] = ListFilterButtonSearchState.ALL;
  }

  updateFilterState();
};

const updateButtonSortState = (key: 'sortCount' | 'sortPrice' | 'sortGrade'): void => {
  if (state[key] === ListFilterButtonSortState.DEFAULT) {
    state[key] = ListFilterButtonSortState.DESC;
  } else if (state[key] === ListFilterButtonSortState.DESC) {
    state[key] = ListFilterButtonSortState.ASC;
  } else if (state[key] === ListFilterButtonSortState.ASC) {
    state[key] = ListFilterButtonSortState.DEFAULT;
  }

  updateFilterState();
};

const updateFilterState = (): void => {
  emit('filter', state);
};

const resetFilterState = (update: boolean = true): void => {
  state.search = '';
  state.searchContext = ListFilterButtonSearchState.ALL;
  state.sortCount = ListFilterButtonSortState.DEFAULT;
  state.sortPrice = ListFilterButtonSortState.DEFAULT;
  state.sortGrade = ListFilterButtonSortState.DEFAULT;

  if (update) {
    updateFilterState();
  }
};

const handleSubmit = (): void => {
  updateFilterState();
};

const showFavoritesModal = (): void => {
  favoritesModal.value = true;
};

const hideFavoritesModal = (): void => {
  favoritesModal.value = false;
};

watch(
  (): string => {
    return locationStore.getActiveSearchWord;
  },
  (): void => {
    if (locationStore.getActiveSearchWord) {
      resetFilterState(false);

      state.search = locationStore.getActiveSearchWord;
      locationStore.activeSearchWord = '';

      updateFilterState();
    }
  },
);

expose<ListFilterExposed>({
  resetFilterState,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("form", {
      class: "flex flex-col gap-2 p-2.5",
      onSubmit: _withModifiers(handleSubmit, ["prevent"])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(ListFilterButton, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (updateButtonSearchState('searchContext')))
          }, {
            default: _withCtx(() => [
              _createVNode(ListFilterButtonContent, {
                icon: require('@/assets/images/list-filter/filter.png'),
                "icon-class": "h-[16px]"
              }, {
                default: _withCtx(() => [
                  (state.searchContext === _unref(ListFilterButtonSearchState).ALL)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_unref(translate)('listFilter.all')), 1)
                      ], 64))
                    : (state.searchContext === _unref(ListFilterButtonSearchState).BY_CATEGORY)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(_unref(translate)('listFilter.byCategory')), 1)
                        ], 64))
                      : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["icon"])
            ]),
            _: 1
          }),
          _createVNode(FieldSearchText, {
            modelValue: state.search,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.search) = $event)),
            placeholder: _unref(translate)('listFilter.itemName'),
            onChange: updateFilterState
          }, null, 8, ["modelValue", "placeholder"]),
          _createVNode(ListFilterButton, {
            variant: _unref(ListFilterButtonVariant).LIGHT,
            onClick: showFavoritesModal
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(translate)('listFilter.favorites')), 1)
            ]),
            _: 1
          }, 8, ["variant"]),
          _createVNode(ListFilterButton, {
            variant: _unref(ListFilterButtonVariant).BRAND,
            tooltip: `${_unref(translate)('generic.comingSoon')}...`,
            disabled: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(translate)('listFilter.status')), 1)
            ]),
            _: 1
          }, 8, ["variant", "tooltip"])
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _renderSlot(_ctx.$slots, "bottom", {}, () => [
          _createVNode(ListFilterButton, {
            tooltip: _unref(translate)('listFilter.sortCount'),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (updateButtonSortState('sortCount')))
          }, {
            default: _withCtx(() => [
              _createVNode(ListFilterButtonContent, {
                icon: require('@/assets/images/list-filter/sort-count.png'),
                class: "gap-4"
              }, {
                default: _withCtx(() => [
                  _createVNode(AppIcon, {
                    src: getListFilterButtonIcon(state.sortCount),
                    class: "h-[20px] scale-125 drop-shadow-md"
                  }, null, 8, ["src"])
                ]),
                _: 1
              }, 8, ["icon"])
            ]),
            _: 1
          }, 8, ["tooltip"]),
          _createVNode(ListFilterButton, {
            tooltip: _unref(translate)('listFilter.sortPrice'),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (updateButtonSortState('sortPrice')))
          }, {
            default: _withCtx(() => [
              _createVNode(ListFilterButtonContent, {
                icon: require('@/assets/images/list-filter/sort-price.png'),
                class: "gap-4"
              }, {
                default: _withCtx(() => [
                  _createVNode(AppIcon, {
                    src: getListFilterButtonIcon(state.sortPrice),
                    class: "h-[20px] scale-125 drop-shadow-md"
                  }, null, 8, ["src"])
                ]),
                _: 1
              }, 8, ["icon"])
            ]),
            _: 1
          }, 8, ["tooltip"]),
          _createVNode(ListFilterButton, {
            tooltip: _unref(translate)('listFilter.sortGrade'),
            onClick: _cache[4] || (_cache[4] = ($event: any) => (updateButtonSortState('sortGrade')))
          }, {
            default: _withCtx(() => [
              _createVNode(ListFilterButtonContent, {
                icon: require('@/assets/images/list-filter/sort-grade.png'),
                class: "gap-4"
              }, {
                default: _withCtx(() => [
                  _createVNode(AppIcon, {
                    src: getListFilterButtonIcon(state.sortGrade),
                    class: "h-[20px] scale-125 drop-shadow-md"
                  }, null, 8, ["src"])
                ]),
                _: 1
              }, 8, ["icon"])
            ]),
            _: 1
          }, 8, ["tooltip"])
        ])
      ])
    ], 40, _hoisted_1),
    (favoritesModal.value)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 0,
          to: "#modal"
        }, [
          _createVNode(ItemFavoritesModal, { onClose: hideFavoritesModal })
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})